import { useState } from 'react';
import { AddedToBasket } from '../Basket/Events/SubjectsBasketEvents';
import { useMessageHandler } from '~/Features/Messaging/useMessageHandler';

// isBasketDisplayed here because of current styling design
interface SubjectsTabsState {
    isBasketDisplayed: boolean;
    mobileBasketVisible: boolean;
}

export const useSubjectsTabModel = () => {
    const [state, setState] = useState<SubjectsTabsState>({
        isBasketDisplayed: false,
        mobileBasketVisible: false,
    });

    useMessageHandler(AddedToBasket.id, () => {
        setState(prevState => ({ ...prevState, isBasketDisplayed: true }));
    });

    const setMobileBasketVisibility = (mobileBasketVisible: boolean) =>
        setState(prevState => ({
            ...prevState,
            mobileBasketVisible,
        }));

    return {
        state,
        setMobileBasketVisibility,
    };
};
